import type { PublicKeyCredentialRequestOptionsJSON } from "@simplewebauthn/server";
import { z } from "zod";

export default {
  params: z.object({}),
  response: z.object({
    webAuthnAuthenticationOptions: z.custom<PublicKeyCredentialRequestOptionsJSON>(),
  }),
};
